<template>
    <div class="columns is-multiline">
        <router-link-blank v-if="!hideIntitule && to" class="column is-paddingless is-12"
                         :to="to"
                         :class="classLigne"
                         :message="adresse.intitule1">
        </router-link-blank>
      <p :class="classLigne" v-if="!hideIntitule && to === null"
         class="column is-paddingless is-12">
        {{ adresse.intitule1 }}
      </p>
        <p :class="classLigne"
          class="column is-paddingless is-12" v-if="adresse.intitule2 && !hideIntitule">
            {{ adresse.intitule2 }}
        </p>
        <p :class="classLigne"
          class="column is-paddingless is-12" v-if="adresse.intitule3 && !hideIntitule">
            {{ adresse.intitule3 }}
        </p>
        <p :class="classLigne"
          class="column is-paddingless is-12"> {{ adresse.adresse1 }}
        </p>
        <p :class="classLigne"
          class="column is-paddingless is-12" v-if="adresse.adresse2">
            {{ adresse.adresse2 }}
        </p>
        <p :class="classLigne"
          class="column is-paddingless is-12" v-if="adresse.adresse3">
            {{ adresse.adresse3 }}
        </p>
        <p :class="classLigne"
          class="column is-paddingless is-12"
            v-if="adresse.codePostal && adresse.ville">
          {{ adresse.codePostal + ' - ' + adresse.ville}}
        </p>
        <p :class="classLigne"
          class="column is-paddingless  is-12" v-else-if="adresse.codePostal">
          {{ adresse.codePostal }}
        </p>
        <p :class="classLigne"
          class="column is-paddingless is-12" v-else-if="adresse.ville">
          {{ adresse.ville }}
        </p>
    </div>
</template>
<script>
import routerLinkBlank from '@/components/general/routerLinkBlank';

export default {
  name: 'adresseDetail',
  components: {
    routerLinkBlank,
  },
  props: {
    adresse: Object,
    hideIntitule: Boolean,
    classLigne: String,
    to: {
      type: Object,
      required: false,
      default: null,
    },
  },
};
</script>
<style scoped>

</style>
